import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetSTTMAlgorithmDataRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Research/Get_STTM_DAILY_STATUS_4G`,
	params: { userId, role }
});

export const GetWeekRequest = (userId, role) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Research/Get_Week`,
	params: { userId, role }
});

// export const GetHTMLStringRequest = (id, cell, userId) => AxiosRequest({
// 	method: 'GET',
// 	url: `${config.API_URL}Research/Get_HTMLString`,
// 	params: { id, cell, userId }
// });
